import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useLocalizeMessage, ModalWindow } from 'libs.nucleus';
/**
 * Component for a modal dialog that allows the user to upload an image via the provided uploader.
 */
export const ImageUploadModal = ({ isOpen, onClose, onUpload, uploader, canceled, disabled, uploaderErrorMessage, }) => {
    const [imageUrl, setImageUrl] = useState('');
    const t = useLocalizeMessage();
    const onSave = () => {
        onUpload?.(imageUrl);
        setImageUrl('');
        onClose();
    };
    const onDelete = () => {
        setImageUrl('');
    };
    const onCancel = () => {
        setImageUrl('');
        onClose(true);
    };
    const savePrimaryButton = {
        label: t('Import'),
        onClick: onSave,
        disabled: !imageUrl,
    };
    const cancelSecondaryButton = {
        label: t('Cancel'),
        onClick: onCancel,
    };
    return (_jsx(ModalWindow, { title: t('Insert image'), isOpen: isOpen, footerPrimaryActionButton: savePrimaryButton, footerSecondaryActionButtons: [cancelSecondaryButton], closeWindow: onCancel, width: 'sm', dataTestId: 'upload-image-modal', children: uploader({ onSuccess: setImageUrl, onDelete, canceled, disabled, errorMessage: uploaderErrorMessage }) }));
};
